import PasswordValidator from 'password-validator';

interface ValidationResultProps {
  validation: string;
  arguments?: number;
  message: string;
}

const schema = new PasswordValidator().is().min(12).has().digits().has().symbols();

export default function validatePassword(password: string): ValidationResultProps[] {
  const validationResults = schema.validate(password, {
    list: true,
    details: true,
  }) as ValidationResultProps[];

  return validationResults;
}
